import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ErrorGeneral = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M11 7h1.998v6.996H11V7ZM12.998 17v-2.005H11V17h1.998Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M7.414 2.586 2.586 7.414A2 2 0 0 0 2 8.828v6.344a2 2 0 0 0 .586 1.414l4.828 4.828A2 2 0 0 0 8.828 22h6.344a2 2 0 0 0 1.414-.586l4.828-4.828A2 2 0 0 0 22 15.172V8.828a2 2 0 0 0-.586-1.414l-4.828-4.828A2 2 0 0 0 15.172 2H8.828a2 2 0 0 0-1.414.586ZM4 8.828 8.828 4h6.344L20 8.828v6.344L15.172 20H8.828L4 15.172V8.828Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default ErrorGeneral;
